import { render } from "./ChannelPoster.vue?vue&type=template&id=6f04c206"
import script from "./ChannelPoster.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelPoster.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/components/ChannelPoster.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f04c206"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f04c206', __exports__)) {
    console.log('reload')
    api.reload('6f04c206', __exports__)
  }
  
  module.hot.accept("./ChannelPoster.vue?vue&type=template&id=6f04c206", () => {
    console.log('re-render')
    api.rerender('6f04c206', render)
  })

}


export default __exports__